/**
 * Types of Playback States
 * 
 * @internal
 */
export enum MKPlaybackState {
    Playing = "playing",
    Paused = "paused",
    Buffering = "buffering"
}